import * as React from 'react';
import PropTypes from 'prop-types';
import { Body } from '../../styled components/Typography';
import { styles } from './RadioGroup.style';

/**
 * The RadioGroup component represents the standard html element `<input type="radio" />` with adjusted styling.
 */

const RadioGroup = ({ children }) => {
  return <div tw="space-y-8">{children}</div>;
};

RadioGroup.propTypes = {
  children: PropTypes.node.isRequired
};

export const Radio = ({
  label = '',
  checked = false,
  onChange = () => {},
  disabled = false,
  ...inputAttributes
}) => {
  return (
    <>
      <label css={styles.label({ disabled })}>
        <input
          css={styles.radioButton}
          type="radio"
          disabled={disabled}
          defaultChecked={checked}
          onChange={onChange}
          {...inputAttributes}
        />
        {label && <Body tw="ml-16 min-w-0">{label}</Body>}
      </label>
    </>
  );
};

Radio.propTypes = {
  value: PropTypes.string.isRequired,
  /** Set to disabled stated */
  disabled: PropTypes.bool,
  /** Fill in the label */
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func
};

RadioGroup.Radio = Radio;

export default RadioGroup;
